import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";

const TITLE = "Calculatrice de temps d'apprentissage du franais - Estimez votre parcours CECRL";
const DESCRIPTION =
  "Calculatrice de temps d'apprentissage du franais - Estimez votre parcours CECRL. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "french learning time calculator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/french-learning-time-calculator/";

const FrenchLearningTimeCalculator = () => {
  const [lessonsPerWeek, setLessonsPerWeek] = useState("");
  const [lessonTime, setLessonTime] = useState("");
  const [timeUnit, setTimeUnit] = useState("minutes");
  const [timeFormat, setTimeFormat] = useState("weeks");
  const [totalWeeklyHours, setTotalWeeklyHours] = useState("");
  const [timeToLevels, setTimeToLevels] = useState({});
  const [error, setError] = useState("");

  const LEVELS = {
    A1: 100,
    A2: 200,
    B1: 400,
    B2: 650,
    C1: 950,
    C2: 1200,
  };

  const calculateTotalHours = (lessons, time, unit) => {
    const timeInHours = unit === "minutes" ? parseFloat(time) / 60 : parseFloat(time);
    return parseFloat(lessons) * timeInHours;
  };

  const calculateTimeForLevels = (weeklyHours) => {
    let result = {};
    let accumulated = 0;
    Object.entries(LEVELS).forEach(([level, hours]) => {
      accumulated += hours;
      result[level] = formatTime(accumulated / weeklyHours);
    });
    return result;
  };

  const formatTime = (weeks) => {
    switch (timeFormat) {
      case "days": return (weeks * 7).toFixed(1) + " jours";
      case "months": return (weeks / 4).toFixed(1) + " mois";
      case "years": return (weeks / 52).toFixed(1) + " ans";
      default: return weeks.toFixed(1) + " semaines";
    }
  };

  const handleCalculate = () => {
    try {
      if (!lessonsPerWeek || !lessonTime) {
        throw new Error("Veuillez entrer le nombre de cours par semaine et la dure moyenne d'un cours.");
      }
      const lessonTimeValue = lessonTime.includes(":")
        ? parseFloat(lessonTime.split(":")[0]) + parseFloat(lessonTime.split(":")[1]) / 60
        : parseFloat(lessonTime);
      const totalHours = calculateTotalHours(parseFloat(lessonsPerWeek), lessonTimeValue, timeUnit);
      setTotalWeeklyHours(totalHours.toFixed(2) + " heures/semaine");
      setTimeToLevels(calculateTimeForLevels(totalHours));
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice estime le temps ncessaire pour atteindre chaque niveau du Cadre Europen
                  Commun de Rfrence (CECRL) en franais, selon votre rythme d'tude hebdomadaire. Le franais
                  est une langue romane considre de difficult moyenne pour la plupart des apprenants.
                </p>
                <p>
                  Le temps rel varie selon votre langue maternelle (notamment si vous parlez dj une autre
                  langue romane comme l'espagnol ou l'italien), votre exposition quotidienne  la langue,
                  la qualit des cours et votre motivation personnelle.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Calculatrice de temps d'apprentissage du franais</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Cours par semaine</label></b>
                    <input
                      type="number"
                      placeholder="Ex : 5"
                      value={lessonsPerWeek}
                      onChange={(e) => setLessonsPerWeek(e.target.value)}
                      className="form-control"
                      style={{ width: "50%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Dure du cours</label></b>
                    <input
                      type="text"
                      placeholder="Ex : 60"
                      value={lessonTime}
                      onChange={(e) => setLessonTime(e.target.value)}
                      className="form-control"
                      style={{ width: "40%" }}
                    />
                    <select
                      value={timeUnit}
                      onChange={(e) => setTimeUnit(e.target.value)}
                      className="form-select ms-2"
                      style={{ width: "25%" }}
                    >
                      <option value="minutes">Minutes</option>
                      <option value="hours">Heures</option>
                    </select>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b><label className="form-label ms-2">Format des rsultats</label></b>
                    <select
                      value={timeFormat}
                      onChange={(e) => setTimeFormat(e.target.value)}
                      className="form-select ms-2"
                      style={{ width: "25%" }}
                    >
                      <option value="days">Jours</option>
                      <option value="weeks">Semaines</option>
                      <option value="months">Mois</option>
                      <option value="years">Ans</option>
                    </select>
                  </div>
                  <br />
                  <button className="btn btn-success" style={{ fontSize: "20px" }} onClick={handleCalculate}>
                    Calculer
                  </button>
                  <br />
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  <br />
                  {totalWeeklyHours && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <hr />
                      <p>Rsultats :</p>
                      <p>Total heures hebdomadaires : <b>{totalWeeklyHours}</b></p>
                      <p><b>{timeToLevels.A1}</b>  du niveau A1  A2</p>
                      <p><b>{timeToLevels.A2}</b>  du niveau A2  B1</p>
                      <p><b>{timeToLevels.B1}</b>  du niveau B1  B2</p>
                      <p><b>{timeToLevels.B2}</b>  du niveau B2  C1</p>
                      <p><b>{timeToLevels.C1}</b>  du niveau C1  C2</p>
                      <p><b>{timeToLevels.C2}</b>  temps total de A1  C2</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Quels sont les niveaux du CECRL pour le franais ?</h2>
              </div>
              <div className="info-section-body">
                <p>Le Cadre Europen Commun de Rfrence pour les Langues dfinit 6 niveaux :</p>
                <ul>
                  <li><strong>A1 (Introductif) :</strong> Expressions familires et phrases trs simples du quotidien.</li>
                  <li><strong>A2 (Intermdiaire) :</strong> Communication sur des sujets familiers et courants.</li>
                  <li><strong>B1 (Seuil) :</strong> Comprhension des points essentiels lis au travail, aux loisirs et aux voyages.</li>
                  <li><strong>B2 (Avanc) :</strong> Comprhension de textes complexes et interaction spontane avec des natifs.</li>
                  <li><strong>C1 (Autonome) :</strong> Expression fluide et spontane pour les besoins sociaux et professionnels.</li>
                  <li><strong>C2 (Matrise) :</strong> Comprhension et expression quasi parfaites  l'oral et  l'crit.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Combien d'heures faut-il pour apprendre le franais ?</h2>
              </div>
              <div className="info-section-body">
                <p>Voici une estimation des heures d'tude cumules pour chaque niveau de franais :</p>
                <table className="table bmi-table">
                  <thead>
                    <tr>
                      <th className="bmi-header">Niveau</th>
                      <th className="bmi-header">Heures cumules</th>
                      <th className="bmi-header">Heures pour ce palier</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>A1 ? A2</td><td>100 h</td><td>100 h</td></tr>
                    <tr><td>A2 ? B1</td><td>300 h</td><td>200 h</td></tr>
                    <tr><td>B1 ? B2</td><td>700 h</td><td>400 h</td></tr>
                    <tr><td>B2 ? C1</td><td>1 350 h</td><td>650 h</td></tr>
                    <tr><td>C1 ? C2</td><td>2 300 h</td><td>950 h</td></tr>
                    <tr><td><strong>Total A1 ? C2</strong></td><td><strong>4 500 h</strong></td><td></td></tr>
                  </tbody>
                </table>
                <p>Le franais est considr comme l'une des langues les plus exigeantes au niveau avanc en raison de sa grammaire complexe, de ses nombreuses exceptions orthographiques et de son accent.</p>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Pourquoi apprendre le franais ?</h2>
              </div>
              <div className="info-section-body">
                <ul>
                  <li><strong>Langue internationale :</strong> le franais est parl par plus de 300 millions de personnes dans 50 pays.</li>
                  <li><strong>Langue de culture :</strong> littrature, cinma, mode, gastronomie  le franais ouvre des portes culturelles uniques.</li>
                  <li><strong>Carrire :</strong> langue officielle de l'ONU, de l'UE, de l'UNESCO et de nombreuses organisations internationales.</li>
                  <li><strong>Voyages :</strong> indispensable en France, Belgique, Suisse, Canada (Qubec), et dans toute l'Afrique francophone.</li>
                  <li><strong>Base pour d'autres langues :</strong> apprendre le franais facilite ensuite l'espagnol, l'italien, le portugais et le roumain.</li>
                </ul>
              </div>
            </div>

            <div className="info-section">
              <div className="info-section-header">
                <h2 style={{ fontSize: "16px" }}>Conseils pour progresser rapidement en franais</h2>
              </div>
              <div className="info-section-body">
                <ul>
                  <li><strong>Lisez en franais chaque jour :</strong> articles, romans lgers, sous-titres  la lecture renforce le vocabulaire et la grammaire.</li>
                  <li><strong>Regardez des films et sries en franais :</strong> sans sous-titres selon votre niveau.</li>
                  <li><strong>Parlez ds le dbut :</strong> n'attendez pas d'tre parfait pour commencer  vous exprimer.</li>
                  <li><strong>Concentrez-vous sur la phontique :</strong> le franais possde des sons absents dans d'autres langues (le "r", les nasales).</li>
                  <li><strong>Utilisez des applications :</strong> Duolingo, Anki, Babbel ou des tuteurs locuteurs natifs peuvent booster votre progression.</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default FrenchLearningTimeCalculator;
